fx.ns("filters.photofilters", class SharpenFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params ? ( this.params.amount || 1 ) : 1;
        this.vignette = this.params ? this.params.vignette : false;

        
    }

    apply(SVGElement)
    {
    	super.apply(SVGElement)
        
        if (this.vignette)
        {
            let baseSVG = SVGElement.parent();

            let gradient = baseSVG.gradient('radial', function(stop) {
                    stop.at(0.2, 'rgba(255,255,255,1)')
                    stop.at(0.7, 'rgba(255,255,255,0.5)')
            })

            let ellipse = baseSVG.ellipse( SVGElement.width() * 1.5, SVGElement.height() * 1.5 )
                                 .move( -SVGElement.width()  / 4, -SVGElement.height() / 4 )
                                 .fill( gradient )

            let mask = baseSVG.mask();

            mask.add(ellipse)
            
            SVGElement.maskWith(mask);

            this.elements.push(gradient);
            this.elements.push(mask);
            this.elements.push(ellipse);
        }

	}

    resize(width, height)
    {
       for (let i = 0; i < this.elements.length; i++)
          if (this.elements[i].type == "ellipse")
              this.elements[i].size( width *1.5, height * 1.5)
                              .move(- width / 4, -height / 4);
    }

	filterFCN(add)
	{
		 add.convolveMatrix([
      		0, -1 * this.amount,  0,
			-1 * this.amount,  6, -1 * this.amount,
			0, -1 * this.amount,  0
  		]);

	}
      
	

});
